export default "__VITE_ASSET__Bc9iKzh8__"